import React from 'react';
import { Platform, StyleSheet, ViewStyle } from 'react-native';

import { GlassViewComponent } from '@/components/common/glass-view';

interface GlassCardProps {
	children: React.ReactNode;
	style?: ViewStyle;
	glassEffectStyle?: 'clear' | 'regular';
	elevation?: number;
}

/**
 * GlassCard component with native iOS glass effect
 * Provides a modern card design with blur and transparency
 */
export const GlassCard: React.FC<GlassCardProps> = ({
	children,
	style,
	glassEffectStyle = 'regular',
	elevation = 2,
}) => {
	const cardStyle: ViewStyle = {
		...styles.card,
		...(Platform.OS !== 'ios' && {
			elevation,
			shadowColor: '#000',
			shadowOffset: { width: 0, height: elevation },
			shadowOpacity: 0.1,
			shadowRadius: elevation * 2,
		}),
		...style,
	};

	return (
		<GlassViewComponent
			style={cardStyle}
			glassEffectStyle={glassEffectStyle}
			isInteractive={true}
		>
			{children}
		</GlassViewComponent>
	);
};

const styles = StyleSheet.create({
	card: {
		borderRadius: 16,
		padding: 16,
		marginVertical: 8,
		marginHorizontal: 16,
		backgroundColor: Platform.OS === 'ios' ? 'transparent' : 'rgba(255, 255, 255, 0.9)',
	},
});
